import styled from 'styled-components';
import Dropzone from 'react-dropzone';

import CtaCard from 'components/ui/CtaCard';
import Icon from 'components/ui/Icon';

import { media } from 'helpers/MediaHelper';
import { colors } from 'helpers/ColorHelper';

import { MdPhotoCamera as FileDropIcon } from 'react-icons/md';

export const StyledOuterContainer = styled.div``;

export const StyledDropzone = styled(Dropzone)`
  width: 100%;
  border: none;
  padding: 0;
  cursor: pointer;
  margin-right: 20px;
`;

const StyledFlexCenterRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: 'row';
`;

export const StyledContainer = styled(StyledFlexCenterRow)`
  min-height: 40px;
  border: ${props =>
    props.isDragActive ? `1px solid ${colors.LIGHT_BLUE_GREY}` : `1px dashed ${colors.GRAY}`};
  border-radius: 8px;
  margin: 10px 0px;
  justify-content: ${props => (props.isDragActive ? 'center' : 'auto')};
  background-color: ${props => (props.isDragActive ? colors.LIGHT_BLUE_GREY : colors.WHITE)};
  cursor: pointer;
`;

export const StyledDropzoneText = styled(StyledFlexCenterRow)`
  line-height: 25px;
  margin: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  justify-content: space-between;
  ${media.mobile`
    justify-content: flex-start;
  `};
`;

export const StyledDropHereText = styled(StyledFlexCenterRow)`
  color: ${props => (props.isDragActive ? colors.PURE_BLUE : colors.SLATE_GREY)};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
`;

export const StyledSpan = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  font-size: 16px;
`;

export const StyledBrowseFileText = styled.span`
  color: ${colors.PURE_BLUE};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
`;

export const StyledViewPDFLink = styled.a`
  flex-grow: 1;
  padding: 0;
  color: ${colors.PURE_BLUE};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
  text-align: right;
`;

export const StyledViewDelete = styled(CtaCard)`
  flex-grow: 1;
  padding: 0;
  color: ${colors.PURE_BLUE};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
  text-align: right;
`;

export const StyledFileContainer = styled(StyledFlexCenterRow)`
  line-height: 25px;
  padding: 8px 15px;
  border-radius: 8px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  justify-content: space-between;
  ${media.mobile`
    justify-content: flex-start;
  `};
  background-color: ${colors.WHITE};
`;

export const StyledImagePreview = styled(StyledFlexCenterRow)`
  color: ${colors.SLATE_GREY};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
  flex-grow: 3;
  ${media.mobile`
    flex-grow: 2;
  `};
`;

export const StyledFileName = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  font-size: 16px;
  margin-left: 10px;
`;

export const StyledImg = styled.img`
  display: block;
  width: 48px; // auto
  height: 48px;
`;

export const StyledDropIcon = styled(FileDropIcon)`
  font-size: 24px;
  margin: 2px 10px 2px 0;
`;

export const StyledError = styled.div`
  color: red;
  margin: 10px;
`;

export const StyledIcon = styled(Icon)`
  font-size: 18px;
`;
